import PropTypes from 'prop-types';
import React from 'react';
import LeftDrawerFooter from '../../../../Footer/LeftDrawerFooter/LeftDrawerFooter';
import DrawerLayout from '../../../Layout/DrawerLayout/DrawerLayout';
import { pageDisplayModePropTypes } from '../../../../../../pages/defaultProps';
import { PAGE_DISPLAY_MODE } from '../../../../../../pages/constants';

import './FooterDrawer.scss';

export default class FooterDrawer extends React.PureComponent {
    static propTypes = {
        /**
         * Props for footer
         */
        footerProps: PropTypes.object.isRequired,
        /**
         * Whether the drawer is open
         */
        isDrawerOpen: PropTypes.bool.isRequired,
        /**
         * whether logo should be shown
         */
        shouldShowLogo: PropTypes.bool.isRequired,
        /**
         * handler for closing
         */
        handleClose: PropTypes.func.isRequired,
        /**
         * style to override default
         */
        className: PropTypes.string,
        /**
         * Value of the view layout the page is in
         */
        pageDisplayMode: pageDisplayModePropTypes.isRequired,
    };

    static defaultProps = {
        handleClose: () => {},
        isDrawerOpen: false,
        footerProps: {},
        athorizedForEmployerNav: false,
        className: '',
        featureFlags: {},
    };

    render() {
        const {
            shouldShowLogo,
            footerProps,
            handleClose,
            isDrawerOpen,
            className,
            pageDisplayMode,
            featureFlags,
        } = this.props;
        const employerLayoutClassName =
            pageDisplayMode === PAGE_DISPLAY_MODE.EMPLOYER_DEFAULT
                ? 'employer-layout-nav'
                : '';

        return (
            <DrawerLayout
                cssClass={`component-Layout-Header-Modules-Drawers-FooterDrawer ${employerLayoutClassName} ${className}`}
                handleClose={handleClose}
                isDrawerOpen={isDrawerOpen}
                shouldShowLogo={shouldShowLogo}
            >
                <LeftDrawerFooter
                    {...footerProps}
                    pageDisplayMode={pageDisplayMode}
                    featureFlags={featureFlags}
                />
            </DrawerLayout>
        );
    }
}
